
export default {
	props: ['item'],
}
